import {ViewCell} from '@mominsamir/ngx-smart-table';
import {Component, EventEmitter, Input, Output, ViewChild} from '@angular/core';
import {NbTooltipDirective, NbTrigger} from '@nebular/theme';

@Component({
    selector: 'ngx-custom-class-cell',
    template: `
        <div
            *ngIf="value.trim()"
            [ngClass]="ngClass(rowData)"
            (click)="onClicked.emit(rowData)"
            (mouseenter)="showTooltip()"
            (mouseleave)="closeTooltip()"
            [nbTooltip]="tooltip(rowData)"
            [nbTooltipTrigger]="NbTrigger.NOOP"
        >
            {{ value }}
        </div>
    `,
    styleUrls: ['./custom-class.component.scss'],
})
export class CustomClassComponent implements ViewCell {
    @ViewChild(NbTooltipDirective, {static: false}) tooltipDirective: NbTooltipDirective;
    readonly NbTrigger = NbTrigger;

    @Input() value: any;
    @Input() rowData: any;

    @Output() onClicked: EventEmitter<any> = new EventEmitter();

    ngClass = (
        rowData: any,
    ):
        | string
        | string[]
        | Set<string>
        | {
              [klass: string]: any;
          } => ({});

    tooltip = (rowData: any): string => '';

    showTooltip() {
        if (this.tooltip(this.rowData)) this.tooltipDirective.show();
    }

    closeTooltip() {
        if (this.tooltip(this.rowData) && this.tooltipDirective.isShown) this.tooltipDirective.hide();
    }
}
